// extracted by mini-css-extract-plugin
module.exports = {"FaqPage":"styles_FaqPage__iATK7","FaqList":"styles_FaqList__UY5iu","card":"styles_card__5jhzt","rowHeader":"styles_rowHeader__V9B00","linkIcon":"styles_linkIcon__zOwE7"};